import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellText from "ds/components/Table/Row/CellText";
import { ManagedUserGroupIntegration } from "types/generated";

const SlackTableNameCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupIntegration>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{integration.integrationName}</TableCellText>
    </TableSimpleCell>
  );
};

export default SlackTableNameCell;
